module.exports = __webpack_public_path__ + "static/media/delet.5ccd140e.svg";